import React, { useCallback, useEffect, useRef, useState } from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import MButton from "../commons/MButton";

const PasswordSidebarCheckArea = ({ callbackNext }) => {
  const { t } = useTranslation();
  const [isScrollDone, setIsScrollDone] = useState(false);
  const targetRef = useRef();

  const next = useCallback(() => {
    callbackNext && callbackNext();
  }, [callbackNext]);

  useEffect(() => {
    const options = {
      root: null, // viewport를 root로 사용합니다.
      rootMargin: '0px', // root와 target 엘리먼트 사이의 여백을 지정합니다.
      threshold: 0.5, // target 엘리먼트가 root와 교차하는 정도를 나타내는 값입니다.
    };

    const callback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsScrollDone(true);
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);
    if (targetRef.current) {
      observer.observe(targetRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return <>
    <Container className="h-100 d-flex flex-column justify-content-between px-4">
      <div className="d-flex flex-column flex-fill gap-3">
        <div className="pt-3 pb-2 text-center fw-bolder" style={{ wordBreak: "keep-all" }}>
          {t("Consent is required to set a password.")}
        </div>
        <div className="position-relative flex-fill d-flex flex-colum gap-3">
          <div
            className="position-absolute px-3 py-4"
            style={{
              inset: 0,
              overflowY: "auto",
              backgroundColor: "#f0f5f7",
              borderRadius: 12
            }}
          >
            <ol className="ps-4 d-flex flex-column gap-3">
              <li>
                {t("I have received an explanation of the Ray Virtual Smile service by the hospital and understand the information provided.")}
              </li>
              <li>
                {t("I have been given the opportunity by the hospital to ask questions about Ray Virtual Smile service.")}
              </li>
              <li>
                {t("I voluntarily agree the proposed use of data in sharing.")}
              </li>
              <li>
                {t("I agree that managing this password is solely my responsible.")}
              </li>
              <li>
                {t("I understand I can withdraw at any time without giving reasons and without being questioned, and that I will not be penalized for withdrawing.")}
              </li>
            </ol>
            <div ref={targetRef} />
          </div>
        </div>
      </div>
      <div className="pb-4 pt-2">
        <MButton
          color={isScrollDone ? "primary" : "gray-300"}
          circle={true}
          height={56}
          css="w-100 text-white"
          disabled={!isScrollDone}
          onClick={next}
        >
          {t("Consent")}
        </MButton>
      </div>
    </Container>

  </>
};

const mapState = (state) => {
  return {};
};

const mapDispatch = dispatch => ({
});

export default connect(mapState, mapDispatch)(PasswordSidebarCheckArea);
